import { GameConstants } from "../../../../GameConstants";
import { GameVars } from "../../../../GameVars";
import { BoardContainer } from "../../board-container/BoardContainer";
import { MinesTurretActor } from "../MinesTurretActor";
import * as Anuto from "../../../../../engine/src";
import { AudioManager } from "../../../../AudioManager";

export class MineActor extends Phaser.GameObjects.Container {

    public anutoMine: Anuto.Mine;

    private mineImage: Phaser.GameObjects.Sprite;
    private arrived: boolean;
    private initialX: number;
    private initialY: number;
    private finalX: number;
    private finalY: number;
    private totalDist: number;
    private distAngle: number;
    private parcialDist: number;

    private f: number;

    constructor(scene: Phaser.Scene, anutoMine: Anuto.Mine, minesTurretActor: MinesTurretActor) {

        super(scene, 0, 0);

        this.anutoMine = anutoMine;
        this.arrived = false;

        this.f = 0;

        this.x = minesTurretActor.x;
        this.y = minesTurretActor.y - 30;

        this.initialX = this.x;
        this.initialY = this.y;

        this.finalX = this.anutoMine.x * GameConstants.CELLS_SIZE;
        this.finalY = this.anutoMine.y * GameConstants.CELLS_SIZE;

        this.totalDist = Math.sqrt((this.finalX - this.x) * (this.finalX - this.x) + (this.finalY - this.y) * (this.finalY - this.y));
        this.distAngle = Math.atan2(this.finalX - this.x, this.finalY - this.y);

        this.parcialDist = 0;

        this.mineImage = this.scene.add.sprite(0, 0, "texture_atlas_2", "torre_6_municion_01");
        this.add(this.mineImage);

        this.visible = false;
    }

    public update(time: number, delta: number): void {

        if (this.arrived) {
            return;
        }

        if (this.f < 24) {
            this.f++;
            return;
        }

        this.parentContainer.bringToTop(this);

        this.visible = true;

        let mult = GameVars.timeStepFactor === 1 ? 12 : 3;

        let offDistY = Math.max(0, Math.sin((this.parcialDist / ((this.anutoMine.moveTime - 24) * mult)) * Math.PI));

        this.x = Math.sin(this.distAngle) * (this.totalDist / ((this.anutoMine.moveTime - 24) * mult)) * this.parcialDist + this.initialX;
        this.y = Math.cos(this.distAngle) * (this.totalDist / ((this.anutoMine.moveTime - 24) * mult)) * this.parcialDist + this.initialY - offDistY * 80;

        this.parcialDist++;

        if (this.parcialDist >= (this.anutoMine.moveTime - 24) * mult) {
            this.mineImage.y += 10;
            this.x = this.finalX;
            this.y = this.finalY;
            this.mineImage.anims.play("torre_6_municion_suelo");
            this.arrived = true;

            AudioManager.playSound("mine_lands");
        }
    }

    public detonate(): void {

        this.mineImage.visible = false;
        
        let explosionEffect = this.scene.add.sprite(0, 0, "texture_atlas_3");
        explosionEffect.setScale(1.8 + .2 * this.anutoMine.turret.level);
        this.add(explosionEffect);

        explosionEffect.anims.play("explosion");

        switch (this.anutoMine.turret.level) {
            case 1:
                AudioManager.playSound("explosion", false, .6);
                break;
            case 2:
                AudioManager.playSound("explosion");
                break;
            case 3:
                AudioManager.playSound("explosion_max");
                break;
            default:
                break;
        }

        explosionEffect.on("animationcomplete", () => {
            BoardContainer.currentInstance.removeMine(this);
        }, this);
    }
}
